import React from 'react'
import { getImage } from '../../services/getAssets'
import { Link } from 'react-router-dom'
import { MdKeyboardArrowRight } from 'react-icons/md'
import './Style.css'
import contactInfo from '../../services/contact-info.json'

const PaginaContato = () => {
  return (
    <div className='pagina-contato'>
      <div className='pagina-contato-container col-md-10'>
        <div className="header">
          <div className="col-xl-12">
            <label>
              <Link to={"/pagina-principal"}>
                Pagina inicial
                <MdKeyboardArrowRight size={20} />
              </Link>
              Contato
            </label>
            <p>Contato</p>
          </div>
        </div>

        <div className='body'>

          <div className='logo-area'>
            <img src={getImage('logo.png')}/>
          </div>

          <div>

            <div>
              <h1>Informações De Contato</h1>
            </div>

            <div className='info-area mt-5'>
              <div className='col-md-4'>
                <p className='title'>Para você e sua empresa</p>
                <p className='subtitle'>Atendimento das 9h às 18h (dias úteis)</p>
              </div>

              <div className='col-md-4'>
                <p className='subtitle'>{contactInfo.telefoneEmpresa}</p>
              </div>

              <div className='col-md-4'>
                <p className='subtitle'>{contactInfo.emailEmpresa}</p>
              </div>

            </div>

            <hr/>

            <div className='info-area'>
              <div className='col-md-4'>
                <p className='title'>SAC - Serviço de Atendimento ao Cidadão</p>
                <p className='subtitle'>Atendimento 24h</p>
              </div>

              <div className='col-md-4'>
                <p className='subtitle'>{contactInfo.telefoneSac}</p>
              </div>

              <div className='col-md-4'>
                <p className='subtitle'>{contactInfo.emailSac}</p>
              </div>
            </div>

            <hr/>

            <div className='info-area'>
              <div className='col-md-4'>
                <p className='title'>Atendimento Central</p>
              </div>

              <div className='col-md-4'>
                <p className='subtitle'>{contactInfo.telefoneCentral}</p>
                <p className='subtitle'>{contactInfo.telefoneCentral2}</p>
              </div>

              { contactInfo.enderecoCentral && contactInfo.enderecoCentral2 ?
                <div className='col-md-4'>
                  <p className='subtitle'>{contactInfo.enderecoCentral}</p>
                  <p className='subtitle'>{contactInfo.enderecoCentral2}</p>
                </div>
              : ""
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default PaginaContato
